module.exports = __webpack_public_path__ + "static/flags/FP-8809d114f81f5855ae0f2f29095f047b.gif";